export default __webpack_public_path__ + "static/media/13-bm.51bb3f7d.webp";